import { render, staticRenderFns } from "./CreatePurchaseComponent.vue?vue&type=template&id=4ff5c006&"
import script from "./CreatePurchaseComponent.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseComponent.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports